import {
  PlatformLanguageCode,
  platformDefaultLanguageCode,
} from '@tov-plus/domain';

export function getLocaleDirection(localeCode: string) {
  return localeCode.toLowerCase().startsWith(PlatformLanguageCode.Hebrew)
    ? 'rtl'
    : 'ltr';
}

export function formatGuestDateTime(
  value: string,
  localeCode = typeof navigator !== 'undefined'
    ? navigator.language
    : platformDefaultLanguageCode,
  timezone?: string | null,
) {
  return new Intl.DateTimeFormat(localeCode, {
    dateStyle: 'medium',
    timeStyle: 'short',
    ...(timezone ? { timeZone: timezone } : {}),
  }).format(new Date(value));
}
